import "./styles.css";

import { CloudAccountController } from "./cloud-account";
import { loadV1Content } from "./v1/content";
import { V1GameEngine, type V1GameSnapshot } from "./v1/engine";
import {
  mountGameRuntime,
  type MountedGameRuntime,
} from "./runtime/game-runtime";

export interface JintuBrowserApi {
  contentCounts(): {
    actors: number;
    enemies: number;
    equipment: number;
    items: number;
    maps: number;
    skills: number;
    troops: number;
  };
  dispose(): Promise<void>;
  engine: V1GameEngine;
  snapshot(): V1GameSnapshot;
}

declare global {
  interface Window {
    __JINTU__: JintuBrowserApi;
  }
}

const root = document.querySelector<HTMLElement>("#game-root");
if (!root) throw new Error("缺少游戏容器 #game-root");

let runtime: MountedGameRuntime | undefined;
let cloudAccount: CloudAccountController | undefined;
const initialize = async (): Promise<void> => {
  const content = await loadV1Content();
  const engine = new V1GameEngine(content);
  root.querySelector("#loading-message")?.remove();
  runtime = await mountGameRuntime(root, engine);
  cloudAccount = new CloudAccountController(engine, {
    apiBase: window.location.hostname.endsWith(".playsnow.top")
      ? "https://api.playsnow.top"
      : "",
    gameId: "growth",
    gameName: "成长版",
  });
  await cloudAccount.initialize();
  root.setAttribute("aria-busy", "false");
  window.__JINTU__ = {
    engine,
    snapshot: () => engine.snapshot,
    contentCounts: () => ({
      actors: 1,
      enemies: content.enemies.length,
      equipment: content.equipment.length,
      items: content.items.length,
      maps: content.maps.length,
      skills: content.skills.length,
      troops: content.troops.length,
    }),
    async dispose(): Promise<void> {
      cloudAccount?.dispose();
      cloudAccount = undefined;
      await runtime?.dispose();
      runtime = undefined;
      root.setAttribute("aria-busy", "true");
    },
  };
};

const showStartupError = (error: unknown): void => {
  root.setAttribute("aria-busy", "false");
  root.replaceChildren();
  const message = document.createElement("p");
  message.id = "fatal-error";
  message.textContent =
    error instanceof Error ? `游戏启动失败：${error.message}` : "游戏启动失败";
  root.append(message);
  console.error(error);
};

const startGame2 = (): void => {
  root.setAttribute("aria-busy", "true");
  root.replaceChildren();
  const message = document.createElement("p");
  message.id = "loading-message";
  message.textContent = "正在载入成长版数据……";
  root.append(message);
  void initialize().catch(showStartupError);
};

root.querySelector<HTMLButtonElement>("#enter-game-2")?.addEventListener("click", startGame2);
